define('controllers/modules/dashboard/dashboard-goal',[
    // libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent
    'controllers/modules/goal/goal'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent
    GoalCtrl
) {

    var DashboardGoalCtrl = GoalCtrl.extend({
        index: function(groupId, userId) {
            this.getLayout().getContent().toggleInfo(false);
        },
    });

    return DashboardGoalCtrl;

});

